/**
 * SmartLinksService - Génère des liens intelligents contextuels
 * Playlists Spotify/YouTube, recettes, lieux, vidéos motivation
 */

const STORAGE_KEY = 'adhd_planner_advanced_settings';

// Playlists par activité et humeur
const PLAYLISTS = {
  spotify: {
    focus: {
      name: 'Deep Focus',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DWZeKCadgRdKQ',
      icon: '🎯'
    },
    productivity: {
      name: 'Productive Morning',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DX8NTLI2TtZa6',
      icon: '💼'
    },
    energetic: {
      name: 'Workout',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DX70RN3TfWWJh',
      icon: '🏃'
    },
    calm: {
      name: 'Peaceful Piano',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DX4sWSpwq3LiO',
      icon: '🎹'
    },
    sleep: {
      name: 'Sleep',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DWZd79rJ6a7lp',
      icon: '🌙'
    },
    cooking: {
      name: 'Cooking & Chill',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DX45grRWk2ghU',
      icon: '🍳'
    },
    cleaning: {
      name: 'Cleaning Motivation',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DXdMm1fONpSSf',
      icon: '🧹'
    },
    motivation: {
      name: 'Motivation Mix',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DXdxcBWuJkbcy',
      icon: '🔥'
    },
    happy: {
      name: 'Happy Hits',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DXdPec7aLTmlC',
      icon: '😊'
    },
    lowEnergy: {
      name: 'Lo-Fi Beats',
      url: 'https://open.spotify.com/playlist/37i9dQZF1DWWQRwui0ExPn',
      icon: '😴'
    }
  },
  youtube: {
    focus: {
      name: 'Lo-Fi Hip Hop - Study/Relax',
      url: 'https://www.youtube.com/watch?v=jfKfPfyJRdk',
      icon: '🎯'
    },
    productivity: {
      name: 'Musique Concentration',
      url: 'https://www.youtube.com/results?search_query=musique+concentration+travail',
      icon: '💼'
    },
    energetic: {
      name: 'Workout Music Mix',
      url: 'https://www.youtube.com/results?search_query=workout+music+mix+2024',
      icon: '🏃'
    },
    calm: {
      name: 'Relaxation Music',
      url: 'https://www.youtube.com/results?search_query=relaxation+music+calm',
      icon: '🎹'
    },
    cooking: {
      name: 'Cooking Music',
      url: 'https://www.youtube.com/results?search_query=cooking+music+chill',
      icon: '🍳'
    },
    cleaning: {
      name: 'Cleaning Playlist',
      url: 'https://www.youtube.com/results?search_query=cleaning+motivation+playlist',
      icon: '🧹'
    },
    motivation: {
      name: 'Motivation Videos',
      url: 'https://www.youtube.com/results?search_query=motivation+discours+français',
      icon: '🔥'
    }
  },
  apple: {
    focus: {
      name: 'Pure Focus',
      url: 'https://music.apple.com/fr/playlist/pure-focus/pl.5f6b0ed0c59e43c9acc3c8a5c8f6e9f9',
      icon: '🎯'
    },
    productivity: {
      name: 'Productivité',
      url: 'https://music.apple.com/fr/browse/productivity',
      icon: '💼'
    },
    calm: {
      name: 'Piano Chill',
      url: 'https://music.apple.com/fr/playlist/piano-chill/pl.ee687be760e546eabf08c5e1df5b7c49',
      icon: '🎹'
    }
  }
};

// Vidéos YouTube par catégorie
const YOUTUBE_VIDEOS = {
  meditation: [
    { name: 'Méditation 5 min - Débutant', url: 'https://www.youtube.com/watch?v=inpok4MKVLM', duration: 5 },
    { name: 'Respiration anti-stress', url: 'https://www.youtube.com/watch?v=qZKsqoQqUKo', duration: 3 },
    { name: 'Méditation guidée calme', url: 'https://www.youtube.com/watch?v=O-6f5wQXSu8', duration: 10 }
  ],
  exercise: [
    { name: 'Yoga 10 min matin', url: 'https://www.youtube.com/watch?v=4pKly2JojMw', duration: 10 },
    { name: 'Stretching complet', url: 'https://www.youtube.com/watch?v=g_tea8ZNk5A', duration: 15 },
    { name: 'HIIT 7 min', url: 'https://www.youtube.com/watch?v=mmq5zZfmIws', duration: 7 }
  ],
  cooking: [
    { name: 'Recettes TDAH faciles', url: 'https://www.youtube.com/results?search_query=recettes+faciles+rapides', duration: 0 },
    { name: 'Meal prep débutant', url: 'https://www.youtube.com/results?search_query=meal+prep+debutant', duration: 0 }
  ],
  motivation: [
    { name: 'Motivation TDAH', url: 'https://www.youtube.com/results?search_query=motivation+tdah+adhd', duration: 0 },
    { name: 'Productivité TDAH', url: 'https://www.youtube.com/results?search_query=productivite+tdah+tips', duration: 0 }
  ],
  relaxation: [
    { name: 'ASMR relaxation', url: 'https://www.youtube.com/results?search_query=asmr+relaxation+sleep', duration: 0 },
    { name: 'Sons de la nature', url: 'https://www.youtube.com/watch?v=eKFTSSKCzWA', duration: 60 }
  ]
};

// Recettes par type de repas
const RECIPES = {
  quickMeals: [
    { name: 'Pâtes carbonara (15 min)', url: 'https://www.marmiton.org/recettes/recette_pates-a-la-carbonara_20632.aspx', time: 15 },
    { name: 'Omelette fromage (10 min)', url: 'https://www.marmiton.org/recettes/recette_omelette-au-fromage_19640.aspx', time: 10 },
    { name: 'Croque-monsieur (5 min)', url: 'https://www.marmiton.org/recettes/recette_croque-monsieur_11418.aspx', time: 5 },
    { name: 'Salade César (15 min)', url: 'https://www.marmiton.org/recettes/recette_salade-cesar_34835.aspx', time: 15 },
    { name: 'Riz sauté (15 min)', url: 'https://www.marmiton.org/recettes/recette_riz-saute-aux-legumes_24139.aspx', time: 15 }
  ],
  breakfast: [
    { name: 'Overnight oats', url: 'https://www.marmiton.org/recettes/recette_overnight-oats_345976.aspx', time: 5 },
    { name: 'Smoothie bowl', url: 'https://www.marmiton.org/recettes/recette_smoothie-bowl-aux-fruits_347826.aspx', time: 10 },
    { name: 'Pancakes rapides', url: 'https://www.marmiton.org/recettes/recette_pancakes-hyper-moelleux_63456.aspx', time: 15 }
  ],
  healthy: [
    { name: 'Buddha bowl', url: 'https://www.marmiton.org/recettes/recette_buddha-bowl_351236.aspx', time: 20 },
    { name: 'Poulet légumes', url: 'https://www.marmiton.org/recettes/recette_poulet-aux-legumes_22167.aspx', time: 25 },
    { name: 'Soupe maison', url: 'https://www.marmiton.org/recettes/recette_soupe-de-legumes_17618.aspx', time: 30 }
  ]
};

// Lieux proches (basé sur 75019 Paris par défaut)
const PLACES_75019 = {
  parks: [
    { name: 'Parc des Buttes-Chaumont', walkTime: 5, url: 'https://www.google.com/maps/dir/46+bis+Avenue+Jean+Jaur%C3%A8s,+75019+Paris/Parc+des+Buttes+Chaumont' },
    { name: 'Parc de la Villette', walkTime: 15, url: 'https://www.google.com/maps/dir/46+bis+Avenue+Jean+Jaur%C3%A8s,+75019+Paris/Parc+de+la+Villette' },
    { name: 'Jardin d\'Éole', walkTime: 20, url: 'https://www.google.com/maps/dir/46+bis+Avenue+Jean+Jaur%C3%A8s,+75019+Paris/Jardin+d%27Eole' }
  ],
  water: [
    { name: 'Canal de l\'Ourcq', walkTime: 10, url: 'https://www.google.com/maps/dir/46+bis+Avenue+Jean+Jaur%C3%A8s,+75019+Paris/Canal+de+l%27Ourcq' },
    { name: 'Bassin de la Villette', walkTime: 10, url: 'https://www.google.com/maps/dir/46+bis+Avenue+Jean+Jaur%C3%A8s,+75019+Paris/Bassin+de+la+Villette' }
  ],
  shops: [
    { name: 'Carrefour City Jaurès', walkTime: 2, url: 'https://www.google.com/maps/search/carrefour+city+avenue+jean+jaures+75019' },
    { name: 'Franprix', walkTime: 5, url: 'https://www.google.com/maps/search/franprix+75019+jean+jaures' },
    { name: 'Lidl Stalingrad', walkTime: 10, url: 'https://www.google.com/maps/search/lidl+stalingrad+paris' }
  ],
  sport: [
    { name: 'Basic-Fit Jaurès', walkTime: 5, url: 'https://www.google.com/maps/search/basic+fit+jaures+paris+19' },
    { name: 'Piscine Georges Vallerey', walkTime: 20, url: 'https://www.google.com/maps/search/piscine+georges+vallerey' }
  ]
};

// Prime Video - Suggestions de séries/films courts
const PRIME_VIDEO = {
  short: [
    { name: 'The Office (épisodes 20 min)', category: 'comedy', url: 'https://www.primevideo.com/search?phrase=the+office' },
    { name: 'Brooklyn Nine-Nine (22 min)', category: 'comedy', url: 'https://www.primevideo.com/search?phrase=brooklyn+nine+nine' },
    { name: 'Parks and Recreation (22 min)', category: 'comedy', url: 'https://www.primevideo.com/search?phrase=parks+and+recreation' }
  ],
  relaxing: [
    { name: 'Bob Ross - Painting', category: 'relaxation', url: 'https://www.primevideo.com/search?phrase=bob+ross' },
    { name: 'Planet Earth', category: 'documentary', url: 'https://www.primevideo.com/search?phrase=planet+earth' }
  ],
  motivational: [
    { name: 'Ted Lasso', category: 'feel-good', url: 'https://www.primevideo.com/search?phrase=ted+lasso' },
    { name: 'Documentaires inspiration', category: 'documentary', url: 'https://www.primevideo.com/search?phrase=documentary+inspirational' }
  ]
};

class SmartLinksService {
  constructor() {
    this.settings = null;
  }

  /**
   * Charger les paramètres utilisateur
   */
  loadSettings() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        this.settings = JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Erreur chargement settings:', e);
    }
    return this.settings;
  }

  /**
   * Obtenir le service de musique préféré
   */
  getPreferredMusicService() {
    this.loadSettings();
    return this.settings?.smartLinks?.preferredMusicService || 'spotify';
  }

  /**
   * Obtenir une playlist pour une activité
   */
  getPlaylistForActivity(activityType, mood = null, energy = null) {
    const service = this.getPreferredMusicService();
    const playlists = PLAYLISTS[service] || PLAYLISTS.spotify;

    // Mapping activité -> type de playlist
    const activityMapping = {
      cooking: 'cooking',
      cleaning: 'cleaning',
      work: 'focus',
      study: 'focus',
      exercise: 'energetic',
      sport: 'energetic',
      walking: 'calm',
      relaxation: 'calm',
      sleep: 'sleep',
      morning: 'productivity',
      meditation: 'calm'
    };

    // Ajuster selon l'énergie
    let playlistType = activityMapping[activityType] || 'focus';

    if (energy && energy <= 2) {
      playlistType = 'lowEnergy';
    } else if (mood && mood <= 2) {
      playlistType = 'calm';
    } else if (mood && mood >= 4) {
      playlistType = 'happy';
    }

    const playlist = playlists[playlistType] || playlists.focus;

    return {
      type: 'playlist',
      service: service,
      ...playlist
    };
  }

  /**
   * Obtenir des vidéos YouTube pour une activité
   */
  getYouTubeVideos(category) {
    const videos = YOUTUBE_VIDEOS[category] || YOUTUBE_VIDEOS.motivation;
    return videos.map(v => ({
      type: 'youtube',
      ...v
    }));
  }

  /**
   * Obtenir des recettes rapides
   */
  getRecipes(mealType = 'quickMeals', maxTime = 30) {
    const recipes = RECIPES[mealType] || RECIPES.quickMeals;
    return recipes
      .filter(r => r.time <= maxTime)
      .map(r => ({
        type: 'recipe',
        ...r
      }));
  }

  /**
   * Obtenir des lieux proches
   */
  getPlacesNearby(category = 'parks') {
    this.loadSettings();

    // Pour l'instant, on utilise les lieux du 75019
    // À terme, on pourrait utiliser l'adresse des settings
    const places = PLACES_75019[category] || PLACES_75019.parks;

    return places.map(p => ({
      type: 'place',
      ...p
    }));
  }

  /**
   * Obtenir des suggestions Prime Video
   */
  getPrimeVideoSuggestions(type = 'short') {
    this.loadSettings();

    // Vérifier si Prime Video est activé
    if (!this.settings?.connectedServices?.primeVideo?.enabled) {
      return null;
    }

    const maxDuration = this.settings.connectedServices.primeVideo.preferences?.maxDuration || 30;

    return {
      type: 'primeVideo',
      maxDuration,
      suggestions: PRIME_VIDEO[type] || PRIME_VIDEO.short
    };
  }

  /**
   * Générer des liens intelligents pour une tâche
   */
  getSmartLinksForTask(task) {
    const taskLower = (task?.task || '').toLowerCase();
    const category = task?.category || 'chore';
    const links = [];

    // Détecter le type de tâche
    const isCooking = ['cuisine', 'repas', 'manger', 'déjeuner', 'dîner', 'petit-déjeuner', 'recette'].some(w => taskLower.includes(w));
    const isExercise = ['sport', 'exercice', 'yoga', 'gym', 'marche', 'course', 'étirement'].some(w => taskLower.includes(w));
    const isCleaning = ['ménage', 'nettoyer', 'ranger', 'lessive', 'vaisselle'].some(w => taskLower.includes(w));
    const isWalking = ['marche', 'balade', 'promenade', 'sortir', 'parc'].some(w => taskLower.includes(w));
    const isShopping = ['courses', 'acheter', 'supermarché', 'magasin'].some(w => taskLower.includes(w));
    const isRelaxation = ['détente', 'repos', 'relaxation', 'méditation', 'pause'].some(w => taskLower.includes(w));
    const isWork = ['travail', 'bureau', 'email', 'réunion', 'projet'].some(w => taskLower.includes(w));

    // Ajouter playlist appropriée
    if (isCooking) {
      links.push(this.getPlaylistForActivity('cooking'));
      links.push(...this.getRecipes('quickMeals').slice(0, 3));
    } else if (isExercise) {
      links.push(this.getPlaylistForActivity('exercise'));
      links.push(...this.getYouTubeVideos('exercise').slice(0, 2));
    } else if (isCleaning) {
      links.push(this.getPlaylistForActivity('cleaning'));
    } else if (isWalking) {
      links.push(...this.getPlacesNearby('parks').slice(0, 3));
      links.push(this.getPlaylistForActivity('walking'));
    } else if (isShopping) {
      links.push(...this.getPlacesNearby('shops').slice(0, 3));
    } else if (isRelaxation) {
      links.push(this.getPlaylistForActivity('relaxation'));
      links.push(...this.getYouTubeVideos('meditation').slice(0, 2));
    } else if (isWork) {
      links.push(this.getPlaylistForActivity('work'));
    }

    // Ajouter suggestion Prime Video pour les récompenses
    if (category === 'reward') {
      const primeLinks = this.getPrimeVideoSuggestions('short');
      if (primeLinks) {
        links.push(primeLinks);
      }
    }

    return links;
  }

  /**
   * Obtenir la suggestion principale pour une tâche (format pour aiService)
   */
  getMainSuggestionForTask(task) {
    const links = this.getSmartLinksForTask(task);
    if (!links || links.length === 0) return null;

    // Regrouper par type
    const playlists = links.filter(l => l.type === 'playlist');
    const recipes = links.filter(l => l.type === 'recipe');
    const places = links.filter(l => l.type === 'place');
    const videos = links.filter(l => l.type === 'youtube');
    const primeVideo = links.find(l => l.type === 'primeVideo');

    // Retourner la suggestion la plus pertinente
    if (recipes.length > 0) {
      return {
        type: 'recipe',
        title: '👨‍🍳 Recettes rapides recommandées',
        items: recipes.map(r => ({ name: r.name, url: r.url }))
      };
    }

    if (places.length > 0) {
      return {
        type: 'place',
        title: '📍 Lieux proches',
        items: places.map(p => ({ name: `${p.name} (${p.walkTime} min)`, url: p.url }))
      };
    }

    if (playlists.length > 0) {
      const playlist = playlists[0];
      return {
        type: 'music',
        title: `${playlist.icon} Musique recommandée`,
        items: [{ name: `${playlist.name} (${playlist.service})`, url: playlist.url }]
      };
    }

    if (videos.length > 0) {
      return {
        type: 'video',
        title: '📺 Vidéos utiles',
        items: videos.map(v => ({ name: v.name, url: v.url }))
      };
    }

    if (primeVideo) {
      return {
        type: 'primeVideo',
        title: '🎬 Récompense - Prime Video',
        items: primeVideo.suggestions.map(s => ({ name: s.name, url: s.url }))
      };
    }

    return null;
  }
}

const smartLinksService = new SmartLinksService();
export default smartLinksService;

export {
  PLAYLISTS,
  YOUTUBE_VIDEOS,
  RECIPES,
  PLACES_75019,
  PRIME_VIDEO
};
